/* unplugin-vue-components disabled */import { render } from "./input-controls.vue?vue&type=template&id=e169779a&scoped=true"
import script from "./input-controls.vue?vue&type=script&lang=js"
export * from "./input-controls.vue?vue&type=script&lang=js"

import "./input-controls.vue?vue&type=style&index=0&id=e169779a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e169779a"],['__file',"src/components/chat-input/input-controls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e169779a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e169779a', __exports__)) {
    api.reload('e169779a', __exports__)
  }
  
  module.hot.accept("./input-controls.vue?vue&type=template&id=e169779a&scoped=true", () => {
    api.rerender('e169779a', render)
  })

}


export default __exports__